import React from 'react';
import './css/nav.css';
import './css/styles.css';
// import {link} from 'react-router-dom';



class Nav extends React.Component{
    render(){
        return(
            // <div className="row">
            //     <div className="col">
               <nav className="navbar navbar-expand-lg navbar-light sticky-top  " style={{backgroundColor:"white"}}>
                <div className="container container2">
                <a className="navbar-brand" href="/">
                    <img src="/assets/images/AIPLEX LOGO.svg" alt="AiPlex" title="AiPlex" width="134px"/>
                </a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div  className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav ml-auto">
                <li className="nav-item homeicon">
                    <a className="nav-link" href="https://www.aiplex.com"><abbr title="Aiplex.com"><img src="/assets/images/home-01.svg"  style={{height:"40px"}}/></abbr></a>
                </li>
                <li className="nav-item dropdown">
                    <a className="nav-link"  href="/about" routerlinkactive="active">ABOUT &nbsp;&nbsp;<span className="menuicon">I</span></a>

                </li>
                <li className="nav-item">
                    <a className="nav-link" href="/advertisers" routerlinkactive="active" >ADVERTISERS&nbsp;&nbsp;<span className="menuicon">I</span></a>
                </li>


                <li className="nav-item">
                    <a className="nav-link" href="/publishers" routerlinkactive="active" >PUBLISHERS&nbsp;&nbsp;<span className="menuicon">I</span></a>

                </li>

                <li className="nav-item">
                    <a className="nav-link" href="/programmatic" routerlinkactive="active">PROGRAMMATIC &nbsp;&nbsp;<span className="menuicon">I</span></a>
                </li>
               
                <li className="nav-item">
                    <a className="nav-link" href="http://affiliates.aiplexads.com/" routerlinkactive="active"> SIGN UP&nbsp;&nbsp;<span className="menuicon">I</span> LOGIN</a>
                </li>

            </ul>
        </div>
    </div>
</nav>
// </div>
//             </div>
        )
    }
}
export default Nav